import { Component, HostBinding, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { TranslationObject } from '@app/core/models';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  imports: [TranslocoDirective, MatSnackBarLabel, MatSnackBarActions, MatButton, MatSnackBarAction],
  standalone: true,
})
export class SnackBarComponent {
  @HostBinding('class') elementClass = 'mat-simple-snackbar';

  data = inject<{
    title?: string;
    messages: TranslationObject[];
    actionLabel: string;
  }>(MAT_SNACK_BAR_DATA);

  private readonly _snackBarRef = inject<MatSnackBarRef<SnackBarComponent>>(MatSnackBarRef);

  onAction(): void {
    this._snackBarRef.dismiss();
  }
}
